import { useState } from "react";
import { useLocation } from "react-router-dom";
import { loginUser } from "../../store/slices/userSlice";
import SignInFlow from "../../components/Auth/SignInFlow";
import CredentialsStep from "./CredentialsStep";

export default function Login() {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <SignInFlow
      // Pages that finish their sign-in here (e.g. reset password) pass the reason along
      initialError={location.state?.error}
      // Back at the first step the email is kept but the password has to be typed again
      onRestart={() => setPassword("")}
      renderFirstStep={({ submit, ...stepProps }) => (
        <CredentialsStep
          {...stepProps}
          email={email}
          password={password}
          onEmailChange={setEmail}
          onPasswordChange={setPassword}
          onSubmit={() => submit(loginUser, { email, password })}
        />
      )}
    />
  );
}
